import { ISalesDocumentTypeId } from '../sales-document-management/models/sales-document-type-id';

export interface TopProductsReq {
  shipmentLocationId: number;
  shippingConditionId: number;
  productLineId: number;
  salesDocumentTypeId: ISalesDocumentTypeId;
  purchaseOrder?: string;
  productColorId?: number;
}
